export default __webpack_public_path__ + "static/media/nodata.b4b8bd2d.svg";